import PromptDialog from "@entrilia/shared/components/dialog/PromptDialog.tsx";
import useClientContext from "../../../../../../../../context/useClientContext.ts";
import ReportGroupsConnector from "../../../../../report-lists/reports/components/ReportGroupsConnector.tsx";
import SaveReportFormWrapper from "../../../../../report-lists/reports/components/SaveReportFormWrapper.tsx";
import type { SaveReportDialogProps } from "../../../viewer/common/Types.ts";
import useSaveReportDialog from "../hooks/useSaveReportDialog.ts";

export default function SaveReportDialog({ report, open, title, saveBtnTitle, onClose }: SaveReportDialogProps) {
  const { clientCode } = useClientContext();
  const { error, onSaveReport, saving } = useSaveReportDialog({
    report,
    onClose,
  });

  return (
    <PromptDialog open={open}>
      <ReportGroupsConnector clientCode={clientCode}>
        <SaveReportFormWrapper
          report={report}
          error={error}
          title={title}
          saveBtnTitle={saveBtnTitle}
          showName
          showLevel
          saving={saving}
          onClose={onClose}
          onSave={onSaveReport}
        />
      </ReportGroupsConnector>
    </PromptDialog>
  );
}
